/**
 * **O aviso de uma peça que só vale no duelo**, na forma que qualquer catálogo
 * pode usar (gate V28H.B).
 *
 * ## Porque a etiqueta é partilhada e a frase não
 *
 * Porque a etiqueta é a mesma coisa: `SOMENTE PVP` diz onde a peça vale, e isso
 * não depende de a peça ser uma joia ou uma carta. Escrevê-la duas vezes seria
 * abrir a porta a duas maiúsculas diferentes no mesmo painel de inventário.
 *
 * A frase é outra coisa: ela nomeia a peça, e "Esta joia" numa carta seria
 * simplesmente falso. Cada catálogo escreve a sua, e a tecnologia assistiva lê
 * a frase e não a sigla - que é a razão por que as duas metades são campos
 * separados em vez de uma string cortada na apresentação.
 *
 * ## Porque isto não decide QUEM recebe o aviso
 *
 * Porque essa pergunta é feita ao CATÁLOGO - `isPvpOnlyJewel`, `isPvpOnlyCard` -
 * e não a este ficheiro. Uma lista de ids escrita aqui seria uma segunda casa
 * para uma decisão que o catálogo já tem, e a que envelhece é sempre a que
 * ninguém lê.
 */

/**
 * **A etiqueta.** Aprovada, e escrita uma vez para todo o inventário.
 *
 * Curta de propósito: vai ao lado do nome numa carta que já tem nome, nível,
 * efeito e estado. Uma frase inteira ali competiria com todos os quatro.
 */
export const PVP_ONLY_BADGE = 'SOMENTE PVP';

/** O que uma superfície mostra: a sigla ao lado do nome, a frase por baixo. */
export interface ModeNotice {
  readonly badge: string;
  readonly note: string;
}

/**
 * O aviso completo, a partir da frase que o catálogo chamador escreveu.
 *
 * Congelado, porque um aviso é uma constante de apresentação e não um objeto
 * que alguém deva poder remendar a caminho do ecrã.
 */
export function pvpOnlyNotice(note: string): ModeNotice {
  return Object.freeze({ badge: PVP_ONLY_BADGE, note });
}
